module.exports = __webpack_public_path__ + "../public/img/beer.3fe68807.png";